// Palet warna enterprise (navy shell + status semantik), diselaraskan dengan design.md.
// Dipakai lewat inline `style` di komponen shell/status agar exact-match dengan hex spec,
// bukan approksimasi Tailwind color scale.

export const NAVY = {
  topbar: '#252d3d',
  topbarBorder: '#1a2030',
  sidebar: '#1d2535',
  sidebarBorder: '#141c2b',
  textActive: '#e8ecf4',
  textMuted: '#8892a4',
  textInactive: '#a8bcce',
  dropdownBg: '#2a3347',
  dropdownBorder: '#3a4560',
  dropdownText: '#c8d0e0',
};

export const STATUS = {
  primary: { text: '#1677ff', icon: '#1677ff', bg: '#e6f4ff', border: '#91caff' },
  valid: { text: '#389e0d', icon: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
  warning: { text: '#d46b08', icon: '#fa8c16', bg: '#fff7e6', border: '#ffd591' },
  critical: { text: '#cf1322', icon: '#f5222d', bg: '#fff2f0', border: '#ffccc7' },
  expired: { text: '#595959', icon: '#8c8c8c', bg: '#f5f5f5', border: '#d9d9d9' },
};
